/**
 * Browser wordings of a failed dynamic `import()` (Chromium, Firefox, Safari, and a chunk served as
 * `text/html`). Matched case-sensitively: a looser match would reload the page on unrelated errors.
 */
const CHUNK_LOAD_FAILURE_MESSAGES: readonly string[] = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'is not a valid JavaScript MIME type',
];

export function isChunkLoadFailure(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  const message = (error as { message?: unknown }).message;
  return typeof message === 'string' && CHUNK_LOAD_FAILURE_MESSAGES.some((fragment) => message.includes(fragment));
}
